export * from "./atoms";
export * from "./molecules";

import { NavItemsAtoms } from "./atoms";
import { NavItemMolecules } from "./molecules";

export const NavItemsComponent = [...NavItemsAtoms, ...NavItemMolecules];
